<script module lang="ts">
	import LucideGithub from '~icons/lucide/github';
	import LucideLinkedin from '~icons/lucide/linkedin';
	import LucideTwitter from '~icons/lucide/twitter';
	import MeteorIconsBluesky from '~icons/meteor-icons/bluesky';
	import FileIconsSvelte from '~icons/file-icons/svelte';
	import MdiDocker from '~icons/mdi/docker';
	import MdiSass from '~icons/mdi/sass';
	import SimpleIconsRust from '~icons/simple-icons/rust';
	import LineiconsDeno from '~icons/lineicons/deno';
	import DeviconPlainTypescript from '~icons/devicon-plain/typescript';
	import SimpleIconsGithub from '~icons/simple-icons/github';
</script>

<script lang="ts">
	const Icons = {
		github: LucideGithub,
		'github-filled': SimpleIconsGithub,
		linkedin: LucideLinkedin,
		twitter: LucideTwitter,
		bluesky: MeteorIconsBluesky,
		svelte: FileIconsSvelte,
		docker: MdiDocker,
		sass: MdiSass,
		rust: SimpleIconsRust,
		deno: LineiconsDeno,
		typescript: DeviconPlainTypescript
	} as const;

	let { name, class: className = '' }: { name: keyof typeof Icons; class?: string } = $props();

	const Icon = Icons[name];
</script>

<Icon class="h-6 w-6 sm:h-5 sm:w-5 {className}" />
